import type { ChartEntry } from "../types";
import styles from "../attendance-card.module.css";
import { formatFullDate, formatMinutesAsHm } from "../utils.ts";

interface WeeklyTooltipProps {
  active?: boolean;
  payload?: Array<{ payload: ChartEntry }>;
}

export const WeeklyTooltip = ({ active, payload }: WeeklyTooltipProps) => {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;

  const showInOut =
    (d.officeIn && d.officeIn !== "--:--") ||
    (d.officeOut && d.officeOut !== "--:--");
  const wfhWithoutPunch = d.status === "wfh" && !showInOut;
  const showHours = d.status !== "weekend" && !wfhWithoutPunch;
  const showDivider = showInOut || showHours;

  return (
    <div className={styles.tooltip}>
      <p className={styles.tooltipDate}>{formatFullDate(d.date)}</p>
      <p className={styles.tooltipStatus}>{d.statusLabel}</p>

      {showDivider ? <hr className={styles.tooltipDivider} /> : null}
      {showInOut ? (
        <>
          {d.officeIn && d.officeIn !== "--:--" ? (
            <div className={styles.tooltipRow}>
              <span className={styles.tooltipKey}>In</span>
              <span className={styles.tooltipVal}>{d.officeIn}</span>
            </div>
          ) : null}
          {d.officeOut && d.officeOut !== "--:--" ? (
            <div className={styles.tooltipRow}>
              <span className={styles.tooltipKey}>Out</span>
              <span className={styles.tooltipVal}>{d.officeOut}</span>
            </div>
          ) : null}
        </>
      ) : null}
      {showHours ? (
        <div className={styles.tooltipRow}>
          <span className={styles.tooltipKey}>Hours</span>
          <span className={styles.tooltipValBold}>
            {d.tooltipHoursLabel ??
              formatMinutesAsHm(Math.round(d.hours * 60))}
          </span>
        </div>
      ) : null}
    </div>
  );
};